"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeRangeContainer = exports.TimeContainer = exports.Time = exports.MeasurementContainer = exports.Date = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Container = styled_components_1.default.div `
  width: 100%;
  position: relative;
  font-family: "Roboto", sans-serif;
  overflow: visible;

  /* Add explicit height for calendar page */
  height: ${(props) => (props.$isCalendarPage ? "100%" : "auto")};
  min-height: ${(props) => (props.$isCalendarPage ? "200px" : "auto")};
  display: flex;
  flex-direction: column;

  @media ${media_1.media.desktop} {
    width: ${(props) => (props.$isCalendarPage ? "100%" : "80%")};
  }

  .highcharts-container {
    overflow: visible;
    /* Ensure container fills available space */
    width: 100% !important;
    height: 100% !important;
  }

  .highcharts-root {
    overflow: visible;
    /* Ensure root fills available space */
    width: 100% !important;
    height: 100% !important;

    .highcharts-scrollbar {
      cursor: ${(props) => (props.$isLoading ? "not-allowed" : "auto")};
      pointer-events: ${(props) => (props.$isLoading ? "none" : "auto")};
      transform: ${(props) => props.$isMobile ? "translate(0, 30px)" : "translate(0, 15px)"};
    }

    .highcharts-container {
      overflow: visible;
    }

    .data-highcharts-chart {
      width: 100%;
      overflow: visible;
    }

    .highcharts-button .highcharts-reset-zoom {
      display: none;
      z-index: -1;
    }

    .custom-arrow {
      position: absolute;
      visibility: visible;
    }
  }
`;
exports.Container = Container;
const MeasurementContainer = styled_components_1.default.div `
  display: flex;
  width: 100%;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  padding-right: 0.5rem;

  @media ${media_1.media.desktop} {
    justify-content: flex-end;
    padding-right: 0;
  }
`;
exports.MeasurementContainer = MeasurementContainer;
const TimeRangeContainer = styled_components_1.default.div `
  display: flex;
  width: calc(100% - 14rem);
  height: 4rem;
  gap: 1rem;
  color: ${colors_1.gray300};
  justify-content: center;
  align-items: center;
  font-weight: 300;
  position: absolute;
  top: 13.8rem;
  left: 6.5rem;
  z-index: 1;
  background-color: ${colors_1.gray100};
  @media ${media_1.media.desktop} {
    justify-content: flex-end;
    padding-right: 0;
    position: inherit;
    top: 0;
    left: 0;
    z-index: 0;
    background-color: transparent;
    width: 100%;
    height: auto;
  }

  .time-container {
    display: flex;
    gap: 0.5rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media ${media_1.media.desktop} {
      flex-direction: row;
    }
  }

  .date {
    font-size: 1.4rem;
    font-weight: 500;
    @media ${media_1.media.desktop} {
      font-size: 1.6rem;
    }
  }
  .time {
    font-size: 1rem;
    font-weight: 300;
    @media ${media_1.media.desktop} {
      font-size: 1.6rem;
    }
  }
`;
exports.TimeRangeContainer = TimeRangeContainer;
const Date = styled_components_1.default.div `
  font-size: 1.4rem;
  font-weight: 500;
  @media ${media_1.media.desktop} {
    font-size: 1.6rem;
  }
`;
exports.Date = Date;
const Time = styled_components_1.default.div `
  font-size: 1rem;
  font-weight: 300;
  @media ${media_1.media.desktop} {
    font-size: 1.6rem;
  }
`;
exports.Time = Time;
const TimeContainer = styled_components_1.default.div `
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${media_1.media.desktop} {
    flex-direction: row;
  }
`;
exports.TimeContainer = TimeContainer;
